export const ALLOWED_IMAGE_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/svg+xml",
] as const;

export const ALLOWED_IMAGE_ACCEPT_ATTR = "image/jpeg, image/png, image/svg+xml";

export const INVALID_IMAGE_FILE_MESSAGE =
  "Please select a valid image file (JPG, PNG, or SVG).";

export function isAllowedImageFile(file: File): boolean {
  return (ALLOWED_IMAGE_MIME_TYPES as readonly string[]).includes(file.type);
}

export function dataTransferHasFiles(dt: DataTransfer): boolean {
  return Array.from(dt.types).includes("Files");
}
